import React from 'react';
import PropTypes from 'prop-types';

export default function Tractor({ width, height }) {
  return (
    <svg width={width} height={height} viewBox="0 0 40 40">
      <g id="icon-tractor">
        <g id="tractor">
          <path
            d="M12.89,34.29c-2.05,1.17-.22-.56-2.53-.08s.05,1.34-2.29,1.08.14-.58-2-1.55-.74,1.11-2.49-.48.46-.38-.71-2.43S1.61,31.29,1.13,29s.59,0,.85-2.39-1.29-.37-.32-2.51.51.31,2.1-1.43S2.93,21.61,5,20.44s.22.55,2.53.07,0-1.33,2.29-1.08-.14.59,2,1.55.74-1.11,2.49.48-.46.39.71,2.43,1.25-.46,1.73,1.85-.6,0-.85,2.38,1.28.37.32,2.52-.51-.32-2.1,1.43S14.94,33.12,12.89,34.29Z"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M39,30.43a4.91,4.91,0,1,1-4.91-4.91A4.91,4.91,0,0,1,39,30.43Z"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M35.32,30.43a1.23,1.23,0,1,1-1.23-1.23A1.23,1.23,0,0,1,35.32,30.43Z"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M1.56,20A10.43,10.43,0,0,1,18.9,30.43"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M19.38,29.2h9.79"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M19.38,26.75H30.71"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M21.82,16.94a5.24,5.24,0,0,1-4,4.78"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.00000011920929px"
          />
          <path d="M36.58,16.93H30.33" fill="none" stroke="#000" />
          <path
            d="M27.67,16.93H20.59L21.82,12H27.9m2.59,0h3.6a2.45,2.45,0,0,1,2.46,2.45V26.13"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M30.41,4.65V19.34a1.24,1.24,0,0,1-1.22,1.27h0A1.25,1.25,0,0,1,28,19.34V4.65Z"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path d="M32.87,17.54v8.59" fill="none" stroke="#000" />
          <path d="M34.71,20.61h2.45" fill="none" stroke="#000" />
          <path d="M34.71,23.06h2.45" fill="none" stroke="#000" />
          <path d="M23.66,19.38h2.46" fill="none" stroke="#000" />
          <path d="M23.66,21.84h2.46" fill="none" stroke="#000" />
          <path d="M21.21,24.29h4.91" fill="none" stroke="#000" />
          <path d="M23.66,14.47a.61.61,0,0,1-.61.62.62.62,0,0,1-.62-.62.61.61,0,0,1,.62-.61A.61.61,0,0,1,23.66,14.47Z" />
          <path d="M26.12,14.47a.62.62,0,0,1-.62.62.61.61,0,0,1-.61-.62.61.61,0,0,1,.61-.61A.61.61,0,0,1,26.12,14.47Z" />
          <path d="M33.48,14.47a.61.61,0,0,1-.61.62.62.62,0,0,1-.62-.62.61.61,0,0,1,.62-.61A.61.61,0,0,1,33.48,14.47Z" />
          <path
            d="M7.09,17V9.56H9.42a1.33,1.33,0,0,1,1.23,1.28l.92,6.37"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M16.29,13.24l1.84-3.19"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M17.35,11.72l4,2.3"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.999999940395355px"
          />
          <path
            d="M13.23,27.36a4.3,4.3,0,0,1-4.3,4.3h0a4.3,4.3,0,0,1-4.29-4.3h0a4.3,4.3,0,1,1,8.59,0Z"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.999999880790711px"
          />
          <path d="M9.55,27.36a.61.61,0,0,1-.62.61.61.61,0,0,1,0-1.22A.61.61,0,0,1,9.55,27.36Z" />
          <path d="M9.55,25.52a.61.61,0,0,1-.62.61.61.61,0,0,1-.61-.61.61.61,0,0,1,.61-.62A.62.62,0,0,1,9.55,25.52Z" />
          <path d="M9.55,29.2a.61.61,0,0,1-.62.61.61.61,0,1,1,0-1.22A.61.61,0,0,1,9.55,29.2Z" />
          <path d="M9.94,28.06a.62.62,0,0,1,.86-.16.61.61,0,1,1-.86.16Z" />
          <path d="M6.91,26a.62.62,0,0,1,.86-.16.6.6,0,0,1,.15.85.61.61,0,1,1-1-.69Z" />
          <path d="M7.89,28.08a.61.61,0,0,0-1,.65.62.62,0,0,0,.85.2A.62.62,0,0,0,7.89,28.08Z" />
          <path d="M11,26.06a.62.62,0,0,0-1,.65.62.62,0,1,0,1-.65Z" />
        </g>
      </g>
    </svg>
  )
}

Tractor.defaultProps = {
  width: '40',
  height: '40'
}

Tractor.propTypes = {
  width: PropTypes.string.isRequired,
  height: PropTypes.string.isRequired
}
